//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "soa-list",
  data() {
    return {
      tabIndex: 1,
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '对账和发票',
        url: 'api/soa/page',
        workflowSearchBean: {},
        tabList:['查询对账单','待处理对账单'],
        property: "soaDate",
        fixRules:{
          rules: [{field: "deleted", option: "LIKE_ANYWHERE", values:['0']}]
        },
        inputCondition: {
          placeholder: '对账单号/供应商名称',
          searchCondition: 'key',
          rules: [{field: "soaNo-supplier.supplierCode-supplier.supplierName", option: "LIKE_ANYWHERE"}]
        },
        selectConfig: []
      },
      configTodo: {
        title: '对账和发票',
        url: 'api/soa/page',
        workflowSearchBean: {},
        tabList:['查询对账单','待处理对账单'],
        property: "soaDate",
        fixRules:{},
        inputCondition: {
          placeholder: '对账单号/供应商名称',
          searchCondition: 'key',
          rules: [{field: "soaNo-supplier.supplierCode-supplier.supplierName", option: "LIKE_ANYWHERE"}]
        },
        selectConfig: [
        ]
      },
      searchData: {},
      list: [],
      workflowId:null
    }
  },
  methods: {
    getTabIndex(e) {
      this.tabIndex = e;
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop() {
      this.$refs.header.getlist(true);
    },
    loadBottom() {
      this.$refs.header.getMore();
    },
    getWorkFlow() {
      this.$get('api/biz-object-parameters/key/soa').then(data => {
        this.workflowId = data.workflowType;
        this.config.workflowSearchBean = {
          workflowId: data.workflowType
        };
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchType: '0',
          searchKey: 'id',
        };
        this.$refs.header.getlist();
      })
    },
    goDetail(requestId){
      this.$router.push('/workflow/'+requestId+'?component=SoaViewComponent')
    }
  },
  mounted() {
    this.init();
    this.$refs.header.tabIndex = this.$route.query.tabIndex || 1;
    this.tabIndex = this.$route.query.tabIndex || 1;
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/soa/soa-list.vue